/* Product Tile Markup - You can play around with this to change the information that appears on the Wishlisted Product tiles */
var wishlistedProducts = [];
var formattedWishlistedProducts = [];
var productCardMarkup = `
<div class="swym-wishlist-grid">
   {{#products}} 
   <div class="swym-wishlist-item swym-is-anchor" data-product-id="{{empi}}">
     <button onClick="onRemoveBtnClick(event)" id="swym-remove-productBtn" aria-label="Delete" data-variant-id="{{epi}}" data-product-id="{{empi}}" data-product-url="{{du}}" class="swym-delete-btn swym-nav swym-nav-1 swym-is-button">
       <span class="swym-icon">
       </span>
     </button>
     <div class="swym-wishlist-image-wrapper">
       <img alt="" class="swym-wishlist-image" data-product-url={{du}} onclick="imageRedirect(event)" src="{{iu}}">
     </div>
     <button class="swym-is-button">
       <a href="{{du}}"aria-label="{{dt}}" class="swym-title swym-title-1">
         {{dt}}
       </a>
      </button>
     {{#hasMoreVariant}}
     {{#options}}
       <div id="swym-variant-select-dropdown">
         <span id="swym-select-text">{{name}}   {{vi}}</span>              
         <select id="swym-custom-wishlist-select" data-option-index="{{position}}" onchange="onVariantSelectChange(event, {{position}}, {{empi}}, {{epi}})">
           {{#selectedValues}} 
              <option {{#selected}} selected {{/selected}}>{{value}}</option>
             {{/selectedValues}} 
         </select>
       </div>
     {{/options}} 
     {{/hasMoreVariant}}
     {{^hasMoreVariant}}
       <div>
         {{#variantName}}
           <span>{{variantName}}</span>
         {{/variantName}}
         <span>{{variantinfo}}</span>
       </div>
     {{/hasMoreVariant}}
     <div class="swym-product-price swym-text swym-text-1" data-variant-id="{{epi}}">
     <div id="swym-price-quantity-wrapper">
        <div id="swym-custom-price" data-variant-id="{{epi}}" class="swym-product-final-price swym-value">
         {{cu}} {{pr}}
       </div>
       <div class="quantity-selector">
        <button class="minus-button" onclick="decreaseQuantity(event)" data-variant-id={{epi}} data-product-id={{empi}}>-</button>
          <input type="number" id="swymCustomQuantityInput" disabled onchange="quantityChange(event)" class="quantity-input" value="1" data-variant-id={{epi}} data-product-id={{empi}}>
        <button class="plus-button" onclick="increaseQuantity(event)" data-variant-id={{epi}} data-product-id={{empi}}>+</button>
      </div>
     </div>
     <div id="swym-item-total" data-price-id={{pr}} data-variant-id={{epi}} data-initial-variant-id={{epi}}>Item Total: </div>
    </div>
     <button onClick="onAddToCartClick(event)" {{^isAvailable}}disabled{{/isAvailable}} id="swym-custom-add-toCartBtn" data-product-name="{{dt}}" data-state-cart="{{#isInCart}} swym-added{{/isInCart}}" data-product-url="{{du}}" data-initial-variant-id="{{epi}}" data-variant-id="{{epi}}" data-product-id="{{empi}}" data-quantity-price="{{pr}}" data-quantity-value="1" class="swym-custom-add-to-cart-button">
        {{^isAvailable}}Sold Out{{/isAvailable}}
        {{#isAvailable}}
          {{#isInCart}}Added to cart{{/isInCart}}
          {{^isInCart}}Add to cart{{/isInCart}}
        {{/isAvailable}}       
   </div>
   {{/products}}
</div>`;

function debounce_leading(func, timeout = 300) {
    let timer;
    return (...args) => {
        if (!timer) {
            func.apply(this, args);
        }
        clearTimeout(timer);
        timer = setTimeout(() => {
            timer = undefined;
        }, timeout);
    };
}

function redirectToCollections() {
  window.location = "https://wholesale.sageandclare.com/collections/all";
}

function customErrorHandling(error) {
    _swat.ui.uiRef.showErrorNotification({ message: error });
  console.log(error,"error");
}

function customSuccessHandling(success) {
    _swat.ui.uiRef.showSuccessNotification({ message: success });
   console.log(error,"error");
}

function imageRedirect(event) {
    window.location = event.target.getAttribute("data-product-url");
}

function shareFormHandler () {
  const modal = document.getElementById("swym-custom-share-container");
  const closeBtn = document.querySelector(".swym-close");
  const parentBody = document.querySelector("body.template-page.swym-ready.swym-buttons-loaded");
  
  closeBtn.addEventListener("click", function() {
    modal.classList.add("swym-hide-container");
    parentBody.classList.remove("swym-hide-overflow");
  });
  
  window.addEventListener("click", function(event) {
    if (event.target == modal) {
      modal.classList.add("swym-hide-container");
      parentBody.classList.remove("swym-hide-overflow");
    }
  });
}

function shareListHandler() {
    const parentSubmitForm = document.getElementById("swym-custom-share-form");
    const shareWishlistButton = document.getElementById("swym-custom-share-button");
    const shareWishlistParent = document.getElementById("swym-custom-share-container");
    const submitShareButton = document.getElementById("swym-custom-share-button");
    const shareFromName = document.getElementById("swym-sender-name");
    const shareToEmail = document.getElementById("swym-recepient-email");
    const shareMessage = document.getElementById("swym-share-message");
    const copyListButton = document.getElementById("swym-custom-share-copy-link");
    const parentBody = document.querySelector("body.template-page.swym-ready.swym-buttons-loaded");

    parentSubmitForm.addEventListener("submit", (event) => {
        event.preventDefault();
        console.log(event);
        let params = {
            toEmailId: shareToEmail.value,
            fromName: shareFromName.value,
            note: shareMessage.value,
            lid: null,
            cprops: {}
        }
        let onSuccess = function (response) {
            console.log("Successfully sent the wishlist contents via Email", response);
            let receiver = params.toEmailId;
            let successMessage = `Successfully shared wishlist with  ${receiver}`;
            customSuccessHandling(successMessage);
        }
        let onError = function (error) {
            customErrorHandling(error);
        }
        _swat.sendListViaEmail(params, onSuccess, onError);
    });

    shareWishlistButton.addEventListener("click", (event) => {
      let shopifyCustomerId = window.SHOPIFY_CUSTOMER_ID;
      let wishlistedProductsLength = document.querySelectorAll(".swym-wishlist-item.swym-is-anchor").length;
      if (shopifyCustomerId != '' && wishlistedProductsLength > 0) {
        shareWishlistParent.classList.remove("swym-hide-container");
        shareFormHandler();
        parentBody.classList.add("swym-hide-overflow");
      }
      else if (wishlistedProductsLength == 0) {
          let noProductsErrorMessage = "Your Wishlist is empty. Click Continue Shopping to add products to your wishlist!";
          customErrorHandling(noProductsErrorMessage);
        }
      else {
        let guestShareErrorMessage = "You must be logged in to share your wishlist. Click 'Save My Wishlist' or the Account button to login!";
        customErrorHandling(guestShareErrorMessage);
      }
    });

    copyListButton.addEventListener("click", function () {
        let lid = null;
        let onSuccess = (link, lid) => {
            console.log("Successfully Generated Link ", link, lid);
            let textToCopy = link;

            navigator.clipboard.writeText(textToCopy)
                .then(function () {
                    console.log("Text copied to clipboard: " + textToCopy);
                    let successMessage = "A shareable wishlist link has been copied to your clipbaord!";
                    customSuccessHandling(successMessage);
                })
                .catch(function (error) {
                    console.error("Unable to copy text: ", error);
                    customErrorHandling(error);
                });
        }
        let onError = (error) => {
            // Error is an xhrObject
            customErrorHandling(error.description);
        }

        _swat.generateSharedListURL(lid, onSuccess, onError);
    });
}

function setQuantityState() {
    let arrayOfObjects = JSON.parse(localStorage.getItem("quantityState"));

    if (arrayOfObjects) {
        for (let i = 0; i < arrayOfObjects.length; i++) {
            let currentVariantId = Number(arrayOfObjects[i].variantId);
            let currentProductId = Number(arrayOfObjects[i].productId);
            let currentQuantityValue = Number(arrayOfObjects[i].qtyValue);
            let addToCartBtn = document.querySelector(`#swym-custom-add-toCartBtn[data-product-id="${currentProductId}"][data-variant-id="${currentVariantId}"]`);
            let inventoryBtn = document.querySelector(`#swymCustomQuantityInput[data-product-id="${currentProductId}"][data-variant-id="${currentVariantId}"]`);
            if (addToCartBtn && inventoryBtn) {
                addToCartBtn.setAttribute("data-quantity-value", currentQuantityValue);
                inventoryBtn.setAttribute("value", currentQuantityValue);
            } else {
                return;
            }

        }
    }
}

function persistQuantityState() {
    let allQuantityButtons = document.querySelectorAll("#swymCustomQuantityInput");
    let quantityValueObjectArray = []
    let quantityValueObject = {};
    for (let i = 0; i < allQuantityButtons.length; i++) {
        quantityValueObject = {
            qtyValue: allQuantityButtons[i].getAttribute("value"),
            variantId: allQuantityButtons[i].getAttribute("data-variant-id"),
            productId: allQuantityButtons[i].getAttribute("data-product-id"),
        }
        quantityValueObjectArray.push(quantityValueObject);
    }
    // localStorage.setItem("quantityState", quantityValueObjectArray);
    localStorage.setItem("quantityState", JSON.stringify(quantityValueObjectArray));
    console.log(quantityValueObjectArray, "quantityValueObjectArray");
}

function initialQuantityCheck(products) {
    products.map((product) => {
        if (product.vi) {
            // let selectedVariant = product.variants.find((variant) => variant.title == product.vi);
            let selectedVariant = product.variants.find((variant) => variant.id == product.epi);
            console.log(selectedVariant, "selectedVariant");
            if (selectedVariant.inventory_quantity < 1) {
                let currentProductId = product.empi;
                let currentVariantId = selectedVariant.id;

                let buttonToDisable = document.querySelector(`#swym-custom-add-toCartBtn[data-product-id="${currentProductId}"][data-variant-id="${currentVariantId}"]`);
                if (buttonToDisable) {
                    buttonToDisable.setAttribute("disabled", true);
                    buttonToDisable.textContent = "Sold Out";
                }
            }
        }
    })
}

function calculateListPrice() {
    let totalPrice = 0;

    let allAddToCartButtons = document.querySelectorAll("#swym-custom-add-toCartBtn");
    allAddToCartButtons.forEach((button) => {
      let qty = button.getAttribute("data-quantity-value");
      let price = button.getAttribute("data-quantity-price");
      let multipliedPrice = qty*price;
      totalPrice += multipliedPrice;
    })
  
    console.log('total price = ', totalPrice);
    document.getElementById("swym-list-value").textContent = `Total Spend - AUD $${totalPrice}`;
}

function setInitialQuantityPrice () {
  let allAddToCartButtons = document.querySelectorAll("#swym-custom-add-toCartBtn");
  allAddToCartButtons.forEach((button) => {
    let qtyValue = button.getAttribute("data-quantity-value");
    let price = button.getAttribute("data-quantity-price");
    let epi = button.getAttribute("data-variant-id");
    let itemToSet = document.querySelector(`#swym-item-total[data-initial-variant-id="${epi}"]`);
    itemToSet.textContent = "Item total: " + Shopify.currency.active + " $ " + price * qtyValue;
  })
}

function updateQuantityPrice (event) {
  let epi = Number(event.target.getAttribute("data-variant-id"));
  let qtyValue = document.querySelector(`#swym-custom-add-toCartBtn[data-initial-variant-id="${epi}"]`).getAttribute("data-quantity-value");
  let priceDiv = document.querySelector(`#swym-item-total[data-initial-variant-id="${epi}"]`);
  let price = priceDiv.getAttribute("data-price-id");
  priceDiv.textContent = "Item total: " + Shopify.currency.active + " $ " + price * qtyValue;
}

function decreaseQuantity(event) {
    let currentProductId = Number(event.target.getAttribute("data-product-id"));
    let currentVariantId = Number(event.target.getAttribute("data-variant-id"));
    const quantityInput = event.target.parentElement.querySelector('#swymCustomQuantityInput');
    let currentQuantity = parseInt(quantityInput.value);
    
    if (currentQuantity > 1) {
        currentQuantity--;
        quantityInput.setAttribute("value", currentQuantity);
    }
  
    setProductQuantity(event, currentProductId, currentVariantId, currentQuantity);
    calculateListPrice();
    updateQuantityPrice(event);
}

function increaseQuantity(event) {
    let currentProductId = Number(event.target.getAttribute("data-product-id"));
    let currentVariantId = Number(event.target.getAttribute("data-variant-id"));
    const quantityInput = event.target.parentElement.querySelector('#swymCustomQuantityInput');
    let currentQuantity = parseInt(quantityInput.value);
    currentQuantity++;
    quantityInput.setAttribute("value", currentQuantity);
    setProductQuantity(event, currentProductId, currentVariantId, currentQuantity);
    calculateListPrice();
    updateQuantityPrice(event);
}

function setProductQuantity(event, productId, variantId, quantity) {
    wishlistedProducts.map((product) => {
        if (product.epi == variantId && product.empi == productId) {
            product.qty = quantity;
        }
    })
    let buttonToUpdate = event.target.parentElement.parentElement.parentElement.parentElement.querySelector("#swym-custom-add-toCartBtn");
    buttonToUpdate.setAttribute("data-quantity-value", quantity);

    persistQuantityState();
}

function onAddAllToCartClick() {
    let allAddToCartBtns = document.querySelectorAll("#swym-custom-add-toCartBtn");
    let globalItemObject = [];
    let removeData = [];
    for (let i = 0; i < allAddToCartBtns.length; i++) {
        if (allAddToCartBtns[i].getAttribute("disabled") == null) {
            allAddToCartBtns[i].setAttribute("data-state-cart", "swym-added");
            allAddToCartBtns[i].textContent = "Added to cart";
            let localObject = {
                epi: Number(allAddToCartBtns[i].getAttribute("data-variant-id")),
                qty: Number(allAddToCartBtns[i].getAttribute("data-quantity-value"))
            };
            globalItemObject.push(localObject);
            let epi = localObject.epi;
           // setTimeout(document.querySelector(`#swym-remove-productBtn[data-variant-id="${epi}"]`).click(), 300); 
        }
    }

    let newObject = JSON.parse(JSON.stringify(globalItemObject));

    _swat.platform.addAllToCart(
        newObject,
        (data) => {
        },
        (error) => {
          console.log(error);
          let wishlistedProductsLength = document.querySelectorAll(".swym-wishlist-item.swym-is-anchor").length;
          if (wishlistedProductsLength == 0) {
            let errorMessage = "Your Wishlist is empty. Click Continue Shopping to add products to your wishlist!"
            customErrorHandling(errorMessage);
          } else {
            let errorMessage = "Heads Up!! Some of your QTY’s are not available, we’ve adjusted the QTY to the maximum amount available.";
            console.log(errorMessage,"errormsg");
            customErrorHandling(errorMessage);
          }
        }
    );
}

let addAllToCartBtn = document.getElementById("swym-custom-add-all-to-cart");
addAllToCartBtn.addEventListener("click", onAddAllToCartClick);

async function showHeader() {
    await new Promise((resolve) => {
        const checkExistence = setInterval(() => {
            const wishlistHeader = document.querySelector("#wishlist-items-header");
            if (wishlistHeader) {
                clearInterval(checkExistence);
                resolve();
            }
        }, 100);
    });

    const wishlistHeader = document.querySelector("#wishlist-items-header");
    wishlistHeader.classList.remove("swym-hide-container");

    shareListHandler();
}

function redicrectToCollections() {
    window.location = "https://sageandclare.com/collections/all";
}

function fetchProducts() {
    window._swat.fetch(function (products) {
        wishlistedProducts = products;
        if (products.length > 0) {
            document.getElementById("empty-wishlist-container").classList.add("swym-hide-container");
        } else if (products.length == 0) {
            document.getElementById("empty-wishlist-container").classList.remove("swym-hide-container");
        }
        calculateListPrice();
    });
}

function onRemoveBtnClick(e) {
    e.preventDefault();
    var epi = +e.currentTarget.getAttribute("data-variant-id");
    var empi = +e.currentTarget.getAttribute("data-product-id");
    var du = e.currentTarget.getAttribute("data-product-url");
    let productTileToRemove = document.querySelector(`.swym-wishlist-item[data-product-id="${empi}"]`);
    productTileToRemove.remove();
    window._swat.removeFromWishList({ epi, empi, du }, function (data) {
        console.log('on delete from wishlist ', data);
        fetchProducts();
    });
}

function getVariantInfo(variants) {
    try {
        let variantKeys = ((variants && variants != "[]") ? Object.keys(JSON.parse(variants)[0]) : []),
            variantinfo;
        if (variantKeys.length > 0) {
            variantinfo = variantKeys[0];
            if (variantinfo == "Default Title") {
                variantinfo = "";
            }
        } else {
            variantinfo = "";
        }
        return variantinfo;
    } catch (err) {
        return variants;
    }
}

function onAddToCartClick(e) {
    e.preventDefault();
    var productId = e.target.getAttribute("data-product-id");
    var variantId = Number(e.target.getAttribute("data-variant-id"));
    var du = e.target.getAttribute("data-product-url");
    var quantityInput = e.target.getAttribute("data-quantity-value");
    var quantity = quantityInput ? Number(quantityInput) : 1;
    let originalButtonState = e.target.innerHTML;
    let productName = e.target.getAttribute("data-product-name");
    
    e.target.innerHTML = "Adding..";
    e.target.setAttribute("aria-disabled", "true");
    e.target.classList.add("is-loading");

    // Format data for cart add
    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', quantity);
    
    // Add section data like the theme expects
    let sections = 'cart-icon-bubble';
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
        sections += `,${cartDrawer.closest('.shopify-section').id.replace('shopify-section-', '')}`;
    }
    formData.append('sections_url', window.location.pathname);
    formData.append('sections', sections);

    // Fetch current cart first
    fetch(`${theme.routes.cart}.js`)
        .then(response => response.json())
        .then(oldCartData => {
            // Add to cart
            fetch(theme.routes.cartAdd, {
                method: 'POST',
                headers: {
                    'Accept': 'application/javascript',
                    'X-Requested-With': 'XMLHttpRequest'
                },
                body: formData
            })
            .then(response => response.json())
            .then(data => {
                if (data.status && data.description) {
                    throw new Error(data.description);
                }
                
                // Update cart icon
                const cartIconBubble = document.getElementById('cart-icon-bubble');
                if (cartIconBubble && data.sections['cart-icon-bubble']) {
                    cartIconBubble.innerHTML = data.sections['cart-icon-bubble'];
                }

                // Update cart drawer if it exists
                if (cartDrawer) {
                    setTimeout(() => {
                        cartDrawer.renderContents(data, theme.settings.afterAtc === 'drawer');
                    }, 700);
                }

                // Get updated cart data
                return fetch(`${theme.routes.cart}.js`)
                    .then(response => response.json())
                    .then(newCartData => {
                        const itemInOldCart = oldCartData.items.find(item => item.variant_id === variantId);

                        // Dispatch appropriate theme event
                        if (itemInOldCart) {
                            document.dispatchEvent(new CustomEvent('on:line-item:change', {
                                bubbles: true,
                                detail: {
                                    cart: newCartData,
                                    variantId: variantId,
                                    oldQuantity: itemInOldCart.quantity,
                                    newQuantity: itemInOldCart.quantity === quantity ? itemInOldCart.quantity : quantity
                                }
                            }));
                        } else {
                            document.dispatchEvent(new CustomEvent('on:cart:add', {
                                bubbles: true,
                                detail: {
                                    cart: newCartData,
                                    variantId: variantId
                                }
                            }));
                        }

                        e.target.innerHTML = "Added to Cart";
                        e.target.setAttribute("data-state-cart", "swym-added");
                    });
            })
            .catch(error => {
                console.error('Error:', error);
                document.dispatchEvent(new CustomEvent('on:cart:error', {
                    bubbles: true,
                    detail: {
                        error: error.message
                    }
                }));
                e.target.innerHTML = originalButtonState;
            })
            .finally(() => {
                e.target.classList.add('is-success');
                e.target.removeAttribute('aria-disabled');
                setTimeout(() => {
                    e.target.classList.remove('is-loading');
                    e.target.classList.remove('is-success');
                }, 1400);
            });
        });
}

function removeMiniMeLabel() {
    let theLabel = document.querySelectorAll(".bss_pl_img");
    for (let i = 0; i < theLabel.length; i++) {
        theLabel[i].remove;
    }
}

function onVariantSelectChange(e, position, productId, epi) {
    let currentEpi = epi;
    var selectedValue = e.target.value;
    var currentProduct = formattedWishlistedProducts.find(item => item.empi == productId);
    var selectedVariant = currentProduct.variants.find(variant => variant[`option${position}`] == selectedValue);
    let currentEmpi = currentProduct.empi;
    let variantArray = currentProduct.productData.variants;
    let currentAddToCartButton = e.target.parentElement.parentElement.querySelector(`#swym-custom-add-toCartBtn[data-product-id="${currentEmpi}"]`);
    let currentInputSelector = document.querySelector(`#swymCustomQuantityInput[data-variant-id="${epi}"]`);
    let newVariantPrice;
    let currentItemPrice = document.querySelector(`#swym-custom-price[data-variant-id="${epi}"]`);
    let currentItemTotalPrice = document.querySelector(`#swym-item-total[data-variant-id="${epi}"]`);
    let discount = currentProduct.discount;
  
    if (currentAddToCartButton) {
        currentAddToCartButton.setAttribute("data-variant-id", selectedVariant.id);
    }

    variantArray.map((item) => {
        if (item.id == selectedVariant.id) {
            let stockValue = item.available;
            if (!stockValue) {
                currentAddToCartButton.setAttribute("disabled", true);
                currentAddToCartButton.textContent = "Sold Out";
            } else {
                currentAddToCartButton.removeAttribute("disabled");
                currentAddToCartButton.textContent = "Add to cart";
            }
          newVariantPrice = (item.price/100) - ((item.price/100) * (discount/100));
          console.log(newVariantPrice,"newVariantPrice");
        }
    });

    currentProduct.selectedOption = {
        ...currentProduct.selectedOption,
        [`option${position}`]: selectedValue
    };

  currentItemPrice.textContent = "AUD " + newVariantPrice;
  currentItemTotalPrice.textContent = "Item total: AUD $ " + newVariantPrice;
  currentItemTotalPrice.setAttribute("data-price-id", newVariantPrice);
  currentAddToCartButton.setAttribute("data-quantity-price", newVariantPrice);
  currentAddToCartButton.setAttribute("data-quantity-value", 1);
  currentInputSelector.setAttribute("value", 1);
  calculateListPrice();
}

function swymRenderWishlist(swat) {
    // Get wishlist items
    var wishlistContentsContainer = document.getElementById("wishlist-items-container");
  
     // Get the discount from customer tag
    var discountTagElement = document.querySelector("#customer-tag");
    var discount = 0;
    if (discountTagElement) {
        discount = parseInt(discountTagElement.getAttribute("data-discount"));
    }
  
    swat.fetch(async (products) => {
        console.log(products, "all products");
        wishlistedProducts = products;
        formattedWishlistedProducts = await Promise.all(products.map(async function (p) {
            console.log('current product', p);
            const jsReq = await fetch(`${p.du.split("?")[0]}.js`);
            const jsRes = await jsReq.json();
            let product = jsRes;
            let values = [];
            console.log(jsRes,"jsRes");
            p = SwymUtils.formatProductPrice(p); // formats product price and adds currency to product Object
            p.isInCart = _swat.platform.isInDeviceCart(p.epi) || (p.et == _swat.EventTypes.addToCart);
            p.variantinfo = (p.vi ? getVariantInfo(p.vi) : "");
            let selectedVariant = product.variants.find((variant) => p.variantinfo == variant.title);
            selectedVariant = selectedVariant ? selectedVariant : product.variants[0];
            p.isAvailable = !!selectedVariant.available;
            p.variantName = product.options[0].name != "Title" ? product.options[0].name : null;
            let optionValues = product.options[0].values.map((item) => {
                return {
                    selected: item == p.vi,
                    value: item
                }
            });
            product.options[0].selectedValues = optionValues;
            p.options = product.options;
            p.variants = product.variants;
            p.discount = discount;
            p.hasMoreVariant = product.variants.length >= 2;
            p.productData = product;

             // Apply the discount to the product price if a discount is available
            if (discount) {
                p.pr = p.pr * ((100 - discount) / 100);
            }

            return p;
        }));

        console.log(formattedWishlistedProducts, "formattedWishlistedProducts");

        if (products.length > 0) {
            document.getElementById("empty-wishlist-container").classList.add("swym-hide-container");
        } else if (products.length == 0) {
            document.getElementById("empty-wishlist-container").classList.remove("swym-hide-container");
        }

        console.log(formattedWishlistedProducts, "formattedWishlistedProducts");

        var productCardsMarkup = SwymUtils.renderTemplateString(productCardMarkup, {
            products: formattedWishlistedProducts
        });
        if (wishlistContentsContainer) {
            wishlistContentsContainer.innerHTML = productCardsMarkup;
            initialQuantityCheck(products);
        } else {
            console.error("Container not found, Wishlist Page element not found");
        }
        showHeader();
        setQuantityState();
        calculateListPrice();
        setInitialQuantityPrice();
    });
}

if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymRenderWishlist); /* Init Here */